import { ComposedTheme, createUseStyles } from '@glu/theming';

const menuButtonStyles = ({
  icons: {
    actionableMenuIcon: {
      menuButtonColor,
      menuButtonHoverBackground,
      menuButtonHoverColor,
      menuButtonPadding,
    },
  },
}: ComposedTheme) => ({
  menuButton: {
    color: menuButtonColor,
    display: 'block',
    lineHeight: 1,
    margin: 0,
    padding: menuButtonPadding,
    textAlign: 'left',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    width: '100%',
    backgroundColor: 'initial',
    border: 'none',

    '&:hover:not([disabled]),&:focus': {
      color: menuButtonHoverColor,
      backgroundColor: menuButtonHoverBackground,
      textDecoration: 'none',
    },
  },
});

export default createUseStyles(menuButtonStyles);
